import * as React from "react";
import { Link } from "@grandvisionhq/common";
import { OneTrustCookieSettingsButton } from "@grandvisionhq/cookie-consent";
const FooterLinks = ({ items }) => {
  return /* @__PURE__ */ React.createElement("ul", { className: "footer__links" }, items.map((item, index) => /* @__PURE__ */ React.createElement("li", { key: `footer-link-${index}`, className: "footer__links-item" }, /* @__PURE__ */ React.createElement(Link, { className: "footer__link", url: item.link?.href ?? "#", label: item.label }))), /* @__PURE__ */ React.createElement("li", { className: "footer__links-item" }, /* @__PURE__ */ React.createElement(OneTrustCookieSettingsButton, { className: "footer__link" })));
};
export {
  FooterLinks,
  FooterLinks as default
};
//# sourceMappingURL=FooterLinks.js.map
